// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
} */
a.active{
  list-style: none;
  text-decoration: none;
  background: #000000 !important;
  width: 100%;
  display: block;
  padding: 20px 0px;
  border-radius: 5px;
  font-weight: 600;
  color: #fff;
}
.homeCard{
  width: 100%;
  height: 100vh;
  margin-top: 100px;
}
.subHomeCard{
  background: #fff;
  margin: 20px 8px;
  padding: 10px;
  
}
.tableCard{
  background: #fff;
  margin: 5px 5px 30px 5px;
  padding-bottom: 20px;
  overflow-x: auto;
}
.MuiTabs-flexContainer.css-heg063-MuiTabs-flexContainer {
  justify-content: space-around;
}
.swal2-container.swal2-top-end.swal2-backdrop-show {
  z-index: 9999 !important;
}
td{
  border: 1px solid #ccc;
  padding: 6px !important;
}
.MuiTabs-flexContainer.css-k008qs {
  display: flex !important;
  justify-content: space-around !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqCG;AACH;EACE,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;;AAEf;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C","sourcesContent":["/* .App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n} */\na.active{\n  list-style: none;\n  text-decoration: none;\n  background: #000000 !important;\n  width: 100%;\n  display: block;\n  padding: 20px 0px;\n  border-radius: 5px;\n  font-weight: 600;\n  color: #fff;\n}\n.homeCard{\n  width: 100%;\n  height: 100vh;\n  margin-top: 100px;\n}\n.subHomeCard{\n  background: #fff;\n  margin: 20px 8px;\n  padding: 10px;\n  \n}\n.tableCard{\n  background: #fff;\n  margin: 5px 5px 30px 5px;\n  padding-bottom: 20px;\n  overflow-x: auto;\n}\n.MuiTabs-flexContainer.css-heg063-MuiTabs-flexContainer {\n  justify-content: space-around;\n}\n.swal2-container.swal2-top-end.swal2-backdrop-show {\n  z-index: 9999 !important;\n}\ntd{\n  border: 1px solid #ccc;\n  padding: 6px !important;\n}\n.MuiTabs-flexContainer.css-k008qs {\n  display: flex !important;\n  justify-content: space-around !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
